export const fmtIDR = (v) =>
  v == null ? "-" : "Rp " + Number(v).toLocaleString("id-ID");

export const fmtTanggal = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
};

export const fmtTanggalSingkat = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short" });
};

export const fmtWaktuEntry = (iso) => {
  if (!iso) return "-";
  return (
    new Date(iso).toLocaleString("id-ID", {
      timeZone: "Asia/Jakarta",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }) + " WIB"
  );
};

export const todayLocal = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const formatRibuan = (digits) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
export const parseRibuan = (str) => Number(String(str).replace(/[^\d]/g, "") || 0);
